import React, { PureComponent } from 'react'
import {
  Grid,
  ListItem,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'

import EditActionComponent from '../../common/EditActionComponent'
import ComplexTerritoryTaxItem from './ComplexTerritoryTaxItem'
import { hasAccess } from '../../../utils/api'
import { getCustomerTypeDisplayName } from '../../../utils/common'
import { ComplexTaxDataContext } from '../TaxOption'

const taxItemsKeyList = ['cityTax', 'countyTax', 'stateTax', 'federalTax']

export default class ComplexTaxOptionItem extends PureComponent {
  onChange = (key) => (propToUpdate, value) => {
    const { data = {} } = this.props

    var newTax = {}
    if (propToUpdate === 'taxOrder' && value === 'PreTaxed') {
      newTax = {
        ...data[key],
        [propToUpdate]: value,
        activeDeliveryFeeTax: false,
      }
    } else {
      newTax = {
        ...data[key],
        [propToUpdate]: value,
      }
    }

    this.props.onChange(key, newTax)
  }

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onEnable = () => {
    const { data } = this.props

    this.props.onChange('active', !data.active, this.onSave)
  }

  renderEnableButton = (active) => {
    return (
      <Button className={`${active ? 'danger' : 'primary'}-button margin`} onClick={this.onEnable}>
        {active ? 'Disable' : 'Enable'}
      </Button>
    )
  }

  render() {
    const {
      data = {},
      editMode,
      showExcise = true,
      showEdit = true,
      isNonCannabis = false,
      allowDelivery,
      nalExciseAfterCityTax,
      isNalTaxesOnly,
      surchargeTerritoryTaxFlag,
      isCDTFAEnabled = false,
      consumerTypes
    } = this.props
    const showDeliveryFee = allowDelivery
    const customerTypeDisplayName = getCustomerTypeDisplayName(consumerTypes, data.consumerType)
    return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <ListItem>
            <Grid container>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <h1 className="table-heading">
                  {customerTypeDisplayName}
                </h1>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div
                  className="full-width"
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  {hasAccess() && showEdit ? (
                    <EditActionComponent
                      editMode={editMode}
                      onSave={this.onSave}
                      onEdit={this.props.enableEdit}
                      onCancel={this.props.onCancel}
                    />
                  ) : null}
                </div>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid item xs={12} sm={6} md={6} lg={6} className="customer_type">
                Customer Type
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                  {customerTypeDisplayName}
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <div className="table-scroll complex-tax-table">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Display Name</TableCell>
                    <TableCell>Tax Rate</TableCell>
                    <TableCell>Compound</TableCell>
                    <TableCell>Tax Order</TableCell>
                    <TableCell>Active</TableCell>
                    {!isNonCannabis && (showExcise ? <TableCell>Tax Excise</TableCell> : null)}
                    {showDeliveryFee ? <TableCell>Tax Delivery Fee</TableCell> : null}
                    {surchargeTerritoryTaxFlag ? <TableCell>Tax Surcharge Fee</TableCell> : null}
                    {isCDTFAEnabled ? <TableCell>CDTFA Tax</TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {taxItemsKeyList.map((taxKey, index) => {
                    const tax = data[taxKey] || {}

                    return (
                      <ComplexTaxDataContext.Consumer>
                        {(taxOptionSettings) => (
                          <ComplexTerritoryTaxItem
                            key={index}
                            tax={tax}
                            editMode={editMode}
                            onChange={this.onChange(taxKey)}
                            showExcise={showExcise}
                            showDeliveryFee={showDeliveryFee}
                            isNonCannabis={isNonCannabis}
                            isNalTaxesOnly={isNalTaxesOnly}
                            nalExciseAfterCityTax={nalExciseAfterCityTax}
                            enableDeliveryFeeBeforeExciseTax={
                              (taxOptionSettings &&
                                taxOptionSettings.exciseTax &&
                                taxOptionSettings.exciseTax.enableDeliveryFeeBeforeExciseTax) ||
                              false
                            }
                            enableSurchargeFeeBeforeExciseTax={
                              (taxOptionSettings &&
                                taxOptionSettings.exciseTax &&
                                taxOptionSettings.exciseTax.enableSurchargeFeeBeforeExciseTax) ||
                              false
                            }
                            onCancel={this.props.onCancel}
                            surchargeTerritoryTaxFlag={surchargeTerritoryTaxFlag}
                            isCDTFAEnabled={isCDTFAEnabled}
                          />
                        )}
                      </ComplexTaxDataContext.Consumer>
                    )
                  })}
                </TableBody>
              </Table>
            </div>
          </ListItem>
        </Grid>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TaxOption/ComplexTaxOptions/ComplexTaxOptionItem.js